<template>
  <div class="content-8__controlbar">
    <div class="content-8__controlbar__item">
      <div class="c8-itemtitle">
        <span class="c8-itemtitle__text">今日长龙统计</span>
      </div>
      <div class="c8-changltx">
        <div v-for="(item, index) in jinRiChangLongStatsList" :key="index" class="c8-changltx__item">
          <span class="c8-changltx__item__text">{{ `${item.fieldName}${item.ruleTypeName}` }}：{{ item.ruleName }} </span>
          <span class="c8-changltx__item__text">{{ item.continuous }} </span>
          <span class="c8-changltx__item__text">期</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCpStatisticsByStatsType_web } from '@/api/desktop/statistic'
export default {
  name: 'JinRiChangLongTongJi',
  props: {
    lotteryCode: {
      type: String,
      required: true,
      default: () => {
        console.error('ShungMianTonJi required key "lotteryCode"')
        return ''
      }
    }
  },
  data() {
    return {
      jinRiChangLongStatsList: ''
    }
  },
  created() {
    this.getTodayChangLongStatistics(this.lotteryCode)
  },
  methods: {
    async getTodayChangLongStatistics(code) {
      const [data, error] = await getCpStatisticsByStatsType_web('nowDragon', {
        code,
        continuous: 2
      })
      if (error) return
      this.jinRiChangLongStatsList = data
    }
  }
}
</script>
